<!-- LEFT SIDEBAR STRUCTURE -->
<div class="menu">
	<div class="icon" (click)="toggleMenu(true)">{{ expand ? 'close' : 'menu' }}</div>
</div>
<div class="items" [ngClass]="{ expand: expand }">
	<div class="item" [ngClass]="{ expand: expand }" (click)="handleNewChat()">
		<div class="icon" title="New Chat" [ngClass]="{ active: activeSection === 'new-chat' }">add_circle</div>
		<div class="title" [ngClass]="{ expand: expand, active: activeSection === 'new-chat' }">New Chat</div>
	</div>

	<div class="item" [ngClass]="{ expand: expand }" (click)="handleUserDashboard()" *ngIf="isAdmin">
		<div class="icon" title="User Dashboard" [ngClass]="{ active: activeSection === 'dashboard' }">dashboard</div>
		<div class="title" [ngClass]="{ expand: expand, active: activeSection === 'dashboard' }">User Dashboard</div>
	</div>

	<div class="item" [ngClass]="{ expand: expand }">
		<div class="icon" title="Chat History" [ngClass]="{ active: activeSection === 'job-history' }" (click)="setJobHistoryActive()">history</div>
		<div class="title" [ngClass]="{ expand: expand, active: activeSection === 'job-history' }" (click)="setJobHistoryActive()">Chat History</div>
	</div>

	<!-- Thread history from conversation API -->
	<ng-container *ngIf="expand && activeSection === 'job-history'">
		<!-- Loading state -->
		<div class="history-item loading" *ngIf="isLoadingHistory">
			<span class="history-text">Loading history...</span>
		</div>

		<!-- Error state -->
		<div class="history-item error" *ngIf="historyLoadError && !isLoadingHistory">
			<span class="history-text">{{ historyLoadError }}</span>
		</div>

		<!-- Thread list with scrolling -->
		<div class="history-items-scroll" *ngIf="!isLoadingHistory && threadSummaries.length > 0">
			<div class="history-item" 
				*ngFor="let thread of threadSummaries" 
				[ngClass]="{ active: selectedJobId === thread.threadId }"
				(click)="selectThread(thread.threadId)"
				title="{{ thread.threadId }}">
				<span class="history-text">{{ thread.chatTitle }}</span>
			</div>
		</div>

		<!-- Empty state -->
		<div class="history-item no-history" *ngIf="!isLoadingHistory && threadSummaries.length === 0 && !historyLoadError">
			<span class="history-text">No conversation history</span>
		</div>
	</ng-container>

	<div class="search-settings" *ngIf="expand">
		<div class="settings-title">Search Settings</div>

		<div class="setting-group">
			<label class="setting-label" for="docSlider">No. of Documents: {{ numberOfDocuments }}</label>
			<input
				id="docSlider"
				type="range"
				class="settings-slider"
				min="1"
				max="10"
				step="1"
				[ngModel]="numberOfDocuments"
				(ngModelChange)="onDocumentsChange($event)" />
		</div>

		<div class="setting-group">
			<label class="setting-label" for="agentSelect">Agent Selection</label>
			<select
				id="agentSelect"
				class="agent-dropdown"
				[ngModel]="selectedAgent"
				(ngModelChange)="onAgentChange($event)">
				<option *ngFor="let agent of availableAgents" [value]="agent.id">
					{{ agent.label }}
				</option>
			</select>
		</div>

	</div>

	<div class="settings-collapsed" *ngIf="!expand" (click)="openSearchSettings()" title="Search Settings">
		<div class="icon">settings</div>
	</div>

	<div class="toggle" [ngClass]="{ expand: expand }">
		<div class="icon" (click)="toggleMenu()">{{ expand ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right' }}</div>
	</div>
</div>

<footer [ngClass]="{ expand: expand }"></footer>
